"use strict";

exports.__esModule = true;
exports.ThresholdGradientPreview = ThresholdGradientPreview;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["thresholds", "style"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Shows a preview of the gradient between thresholds in a list.
 */
function ThresholdGradientPreview(_ref) {
  var thresholds = _ref.thresholds,
    inputStyle = _ref.style,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var background = "transparent";
  if (thresholds.length === 1) {
    background = thresholds[0][1];
  } else if (thresholds.length > 1) {
    var linearGradient = thresholds.map(function (_ref2) {
      var value = _ref2[0],
        color = _ref2[1];
      return color + " " + value + "%";
    }).join(",");
    background = "linear-gradient(to right, " + linearGradient + ")";
  }
  var style = Object.assign({}, inputStyle, {
    background: background
  });
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, extra, {
    style: style
  }));
}